'use client'

import {
  FloatingFocusManager,
  FloatingList,
  useTransitionStyles
} from '@floating-ui/react'
import React, { PropsWithChildren, FC, HTMLAttributes } from 'react'

import { useSelectContext } from './select'
import { cn } from 'design-system/utils/cn'

export const SelectContent: FC<
  PropsWithChildren<HTMLAttributes<HTMLDivElement>>
> = ({ children, style: propsStyle, className, ...props }) => {
  const {
    context,
    refs,
    getFloatingProps,
    elementsRef,
    labelsRef,
    y,
    x,
    strategy
  } = useSelectContext()

  const { isMounted, styles } = useTransitionStyles(context, {
    duration: { open: 300, close: 200 },
    initial: {
      opacity: 0,
      transform: 'scale(0.8)'
    }
  })

  if (!isMounted && labelsRef.current.length > 0) return null

  return (
    <FloatingFocusManager context={context} modal={false}>
      <div
        ref={refs.setFloating}
        style={{
          position: strategy,
          top: Math.round(y ?? 0),
          left: Math.round(x ?? 0),
          ...styles,
          ...propsStyle
        }}
        {...getFloatingProps()}
        className={cn(
          'z-5 flex w-max flex-col gap-1 overflow-hidden rounded-xl border border-slate-200 bg-white p-1 shadow-md',
          className
        )}
        {...props}>
        <FloatingList elementsRef={elementsRef} labelsRef={labelsRef}>
          {children}
        </FloatingList>
      </div>
    </FloatingFocusManager>
  )
}
